var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    viewBox: "0 0 100 100",
    y: 0,
    x: 0,
    xmlns: "http://www.w3.org/2000/svg",
    id: "\\u5716\\u5C64_1",
    width: "200px",
    height: "200px",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      width: "100%",
      height: "100%",
      backgroundSize: "initial",
      backgroundRepeat: "initial",
      backgroundPositionY: "initial",
      backgroundPositionX: "initial",
      backgroundOrigin: "initial",
      backgroundImage: "initial",
      backgroundClip: "initial",
      backgroundAttachment: "initial",
      animationPlayState: "paused"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-scale",
    style: {
      transformOrigin: "50% 50%",
      transform: "rotate(0deg) scale(0.8, 0.8)",
      animationPlayState: "paused"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M79.875 47.332a29.81 29.81 0 0 0-1.794-7.897l7.96-6.804a40.146 40.146 0 0 0-11.102-13.893l-8.395 6.239a29.87 29.87 0 0 0-7.296-3.517l-.356-10.455C56.031 10.355 53.058 10 50 10s-6.031.355-8.892 1.004l-.356 10.456a29.872 29.872 0 0 0-7.296 3.517l-8.395-6.239a40.146 40.146 0 0 0-11.102 13.893l7.96 6.804a29.828 29.828 0 0 0-1.794 7.897L10 50.009a39.831 39.831 0 0 0 3.948 17.34l10.286-1.982a30.134 30.134 0 0 0 5.054 6.324l-4.217 9.579a39.835 39.835 0 0 0 16.021 7.721l4.86-9.271c1.325.179 2.674.28 4.048.28s2.723-.101 4.047-.279l4.86 9.271a39.835 39.835 0 0 0 16.021-7.721l-4.217-9.579a30.16 30.16 0 0 0 5.054-6.324l10.286 1.982a39.831 39.831 0 0 0 3.948-17.34l-10.124-2.678zM50 65c-8.284 0-15-6.716-15-15 0-8.284 6.716-15 15-15s15 6.716 15 15c0 8.284-6.716 15-15 15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfig);
export default __webpack_public_path__ + "static/media/config.72c5da0b1473d3a3c7c95320eb4222e3.svg";
export { ForwardRef as ReactComponent };